import {
  APIRequest,
  PaginatedAPIRequest,
  createIndirectAPIActionGenerator,
  createIndirectPaginationAPIActionGenerator,
} from 'utils/apidata';
import { StaticFilter } from '../models/staticFilters';

export type ListProjectStaticFiltersRequest =
  PaginatedAPIRequest<StaticFilter> & {
    projectUUID: string;
    pageNumber?: number;
  };

export type CreateProjectStaticFilterRequest = APIRequest<null> & {
  projectUUID: string;
  engine: string;
  issueName: string;
  severity: string;
  displayName: string;
};

export type DeleteProjectStaticFilterRequest = APIRequest<null> & {
  projectUUID: string;
  filterUUID: string;
  filter: StaticFilter;
};

export const getStaticFiltersKey = (
  request: ListProjectStaticFiltersRequest
): string => {
  return `${request.projectUUID}`;
};

export function getStaticFiltersPageID(
  request: ListProjectStaticFiltersRequest
) {
  return `${request.pageNumber ?? 1}`;
}

export const generators = {
  pages: createIndirectPaginationAPIActionGenerator<
    ListProjectStaticFiltersRequest,
    StaticFilter
  >({
    prefix: 'PROJECTS/STATIC_FILTERS/PAGES',
    getKey: getStaticFiltersKey,
    getPageID: getStaticFiltersPageID,
  }),
  create: createIndirectAPIActionGenerator<
    CreateProjectStaticFilterRequest,
    null
  >({
    prefix: 'PROJECTS/STATIC_FILTERS/CREATE',
    getKey: (request) => request.projectUUID,
  }),
  delete: createIndirectAPIActionGenerator<
    DeleteProjectStaticFilterRequest,
    null
  >({
    prefix: 'PROJECTS/STATIC_FILTERS/DELETE',
    getKey: (request) => request.filterUUID,
  }),
};
